export default "__VITE_ASSET__7f175e90__"